// "MENUS LISTING" PAGE
import {VUE_INSTANCE_DELIMITERS} from '@/js/global/config';
import {FUNNEL_VUE_INSTANCE_ID, SCROLL_VUE_COMPONENT_CONFIG} from '@funnel/_config/vue';

const main = async () => {
   const [
      {default: Vue},
      {ModalPlugin},
      VueScrollTo,
      {GtmEcommerceHelperMixin, GtmEventsMenusListingMixin},
   ] = await Promise.all([
      import(/* webpackChunkName: "vue" */ 'vue'),
      import(/* webpackChunkName: "bs-funnel-menus-listing" */ 'bootstrap-vue'),
      import(/* webpackChunkName: "vue-scrollto" */ 'vue-scrollto'),
      import(/* webpackChunkName: "gtm-mixins" */ '@/js/funnel/_mixins/gtm'),
   ]);

   Vue.use(ModalPlugin);

   // for scrolling the customer around the page.
   // search for "$scrollTo" in this file to see how to use it.
   Vue.use(VueScrollTo, SCROLL_VUE_COMPONENT_CONFIG);


   // Create our vue instance
   const vm = new Vue({
      name: 'MenusListingPage',
      el: FUNNEL_VUE_INSTANCE_ID,
      delimiters: VUE_INSTANCE_DELIMITERS,
      mixins: [
         GtmEcommerceHelperMixin,
         GtmEventsMenusListingMixin,
      ],
      data: {
         modals: {
            loading: {show: false},
         },
      },
      methods: {
         /**
          * Report a GTM event when a menu is clicked by the customer.
          *
          * @param menuVueRef {string}
          * @param event {object}
          */
         onMenuClick(menuVueRef, event) {
            event.preventDefault();
            const isReported = this.gtmSelectMenu(menuVueRef);
            if (isReported) {
               // let the gtm event get fired off before the page changes
               setTimeout(() => {
                  window.location.href = event.target.href;
               }, 1000);
            }
            else {
               window.location.href = event.target.href;
            }
         },
      },
   });

   return vm;
};

// Execute async function
main().then((vm) => {
});

// Accept HMR as per: https://webpack.js.org/api/hot-module-replacement#accept
if (module.hot) {
   module.hot.accept();
}